<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">
        <v-form>
          <v-card class="login_form type2 type3" flat>
            <h2 class="logo mb-25"><v-img src="~@/assets/img/logo_auth.png" alt="EGPO" @click="$router.push('/main')" style="cursor:pointer;"></v-img></h2>
            <h3 class="out_title mb-15">{{ $t('signup.title') }}</h3>
            <h4 class="out_subtitle mb-35">{{ $t('signup.common.regist.success_sub_title') }}</h4>

            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-25 mt-25">
                  <div class="d-flex">
                    <div>{{ res_msg }}</div>
                  </div>

                  <!-- <h2 class="nec_title mb-15" style="text-align: center">{{ res_msg }}</h2> -->
                </v-col>
              </v-row>
              <v-row class="ma-0 btn_wrap pb-50">
                <v-btn class="sign_in_btn type2 type4" text style="margin: 0 auto" @click="fnGoMain()">{{ $t('common.button.ok') }}</v-btn>
              </v-row>
            </v-card-text>

          </v-card>
        </v-form>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      res_msg_en : this.$t('signup.agent.regist.fields.success'),
      res_msg_ar : this.$t('signup.agent.regist.fields.success'),
      res_msg : ''
    }
  },
  created () {
    this.$vuetify.rtl = false
    this.$i18n.locale = 'en'
    this.$vuetify.lang.current = 'en'
  },
  mounted () {
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
		fnInit() {
      if(this.$i18n.locale == 'en'){
        this.res_msg = this.res_msg_en
      }else{
        this.res_msg = this.res_msg_ar
      }
    },

    fnGoMain(){
      this.$router.push('/signin')
    }
  }
}
</script>